import { Link } from "react-router-dom";

const exploreLinks = [
  { label: "Compare XM Hub", href: "/compare" },
  { label: "Platform Rankings", href: "/rankings" },
  { label: "Forex Academy", href: "/academy" },
];

const compareLinks = [
  { label: "XM vs Tickmill", href: "/compare/xm-vs-tickmill" },
  { label: "XM vs FxPro", href: "/compare/xm-vs-fxpro" },
  { label: "XM vs IC Markets", href: "/compare/xm-vs-icmarkets" },
  { label: "XM vs Axi", href: "/compare/xm-vs-axi" },
  { label: "XM vs FXTM", href: "/compare/xm-vs-fxtm" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B0F19] border-t border-[#1F2937]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        {/* Desktop Layout */}
        <div className="hidden md:grid md:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center mb-5">
              <img src="/images/footer_logo.png" alt="ForexChoiceLab" className="h-8 w-auto min-w-[180px] object-contain" />
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed max-w-xs">
              Independent, data-driven broker reviews and comparisons. We test, measure, and report so you can trade with confidence.
            </p>
          </div>

          {/* Explore Column */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold text-sm mb-5">Explore</h4>
            <ul className="space-y-3">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#F8FAFC] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Compare Column */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold text-sm mb-5">Compare</h4>
            <ul className="space-y-3">
              {compareLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-[#94A3B8] hover:text-[#F8FAFC] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden">
          {/* Brand */}
          <div className="mb-8">
            <Link to="/" className="flex items-center mb-3">
              <img src="/images/footer_logo.png" alt="ForexChoiceLab" className="h-8 w-auto min-w-[180px] object-contain" />
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              Independent, data-driven broker reviews and comparisons.
            </p>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 gap-8">
            {/* Explore */}
            <div>
              <h4 className="text-[#F8FAFC] font-semibold text-sm mb-4">Explore</h4>
              <ul className="space-y-3">
                {exploreLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-[#94A3B8] hover:text-[#F8FAFC] text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Compare */}
            <div>
              <h4 className="text-[#F8FAFC] font-semibold text-sm mb-4">Compare</h4>
              <ul className="space-y-3">
                {compareLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-[#94A3B8] hover:text-[#F8FAFC] text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1F2937]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">
          <p className="text-center text-xs text-[#64748B]">
            &copy; 2026 XMReview. All rights reserved. Independent broker analysis.
          </p>
        </div>
      </div>
    </footer>
  );
}